var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('router-view'),(_vm.$route.name !== 'Index')?_c('FooterBar'):_vm._e(),_c('ToTop',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBackToTop),expression:"showBackToTop"}]}),(_vm.isShallow())?_c('Asides'):_vm._e(),(_vm.wxData && _vm.wxData.id)?_c('CustomerService'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }